import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { API } from '@/utils/api';

export const MOVES = {
  mount: { label: 'Déstocker', title: 'Déstocker – pneus montés sur le véhicule', btn: 'bg-blue-600 hover:bg-blue-700' },
  unmount: { label: 'Entreposer', title: 'Entreposer – pneus remis en stock', btn: 'bg-emerald-600 hover:bg-emerald-700' },
  return: { label: 'Rendu', title: 'Rendu au client', btn: 'bg-slate-700 hover:bg-slate-800' },
};

const nowLocal = () => { const d = new Date(); d.setMinutes(d.getMinutes() - d.getTimezoneOffset()); return d.toISOString().slice(0, 16); };

export const TireMoveDialog = ({ move, storage, onClose, onDone }) => {
  const [by, setBy] = useState('');
  const [date, setDate] = useState(nowLocal());
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (move) { setBy(''); setDate(nowLocal()); } }, [move]);

  const confirm = async () => {
    if (!by.trim()) { toast.error('Indiquez votre nom'); return; }
    setBusy(true);
    try {
      await axios.put(`${API}/gardiennage/${storage.id}/${move}`, { by: by.trim(), date });
      toast.success(`${MOVES[move].label} confirmé par ${by.trim()}`);
      onDone();
    } catch (e) { toast.error(e.response?.data?.detail || 'Action impossible'); }
    finally { setBusy(false); }
  };

  return (
    <Dialog open={!!move} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="tire-move-dialog">
        <DialogHeader>
          <DialogTitle>{move && MOVES[move].title}</DialogTitle>
          <DialogDescription>{storage?.client_name} · {storage?.vehicle_plate} {storage?.tire_brand} {storage?.tire_dimension}</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <div><label className="text-xs font-medium text-slate-600">Nom de la personne</label>
            <Input value={by} onChange={e => setBy(e.target.value)} placeholder="Votre nom" autoFocus data-testid="tire-move-by" /></div>
          <div><label className="text-xs font-medium text-slate-600">Date et heure</label>
            <Input type="datetime-local" value={date} onChange={e => setDate(e.target.value)} data-testid="tire-move-date" /></div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} data-testid="tire-move-cancel">Annuler</Button>
          <Button className={move ? MOVES[move].btn : ''} disabled={busy} onClick={confirm} data-testid="tire-move-confirm">Confirmer</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
